import Vue from 'vue'
import VueRouter from 'vue-router'
import { store } from '../store/store'

// routes import
import routes from './routes'

Vue.use(VueRouter)

// configure router
const router = new VueRouter({
    mode: 'history',
    routes, // short for routes: routes
    linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {

    let userRoles = localStorage.getItem('app_user')
    userRoles = localStorage.getItem('app_user') != null ? JSON.parse(localStorage.getItem('app_user')).roles : []
    
    if(to){
        if(to.matched.some(record => (record.name === 'Logout'))){
            store.commit('logout');
            next({
                path: '/auth/login'
            });
        }
        else if(to.matched.some(record => (record.name === 'Login'))){
            if (localStorage.getItem('app_user_tokens') !== null) {
                if(userRoles.includes("admin"))
                    next({
                        path: '/dashboard/admin',
                        params: { nextUrl: to.fullPath }
                    });
                else if(userRoles.includes("teacher"))
                    next({
                        path: '/dashboard/teacher',
                        params: { nextUrl: to.fullPath }
                    });
                else if(userRoles.includes("student"))
                    next({
                        path: '/dashboard/student',
                        params: { nextUrl: to.fullPath }
                    });
                else
                    next({
                        path: '/dashboard',
                        params: { nextUrl: to.fullPath }
                    });
            }
            else{
                next();
            }
        }
        else if (to.matched.some(record => record.meta.auth)) {
            // check for login
            if (localStorage.getItem('app_user_tokens') === null) {
                next({
                    path: '/auth/login',
                    params: { nextUrl: to.fullPath }
                });
            }
            else{
                
                // check for roles
                // console.log(to.matched.some((record) => userRoles.some((role) => record.meta.roles && record.meta.roles.indexOf(role))));

                // let hasRole = to.matched.some((record) => {
                //     if(record.meta.roles){
                //         return record.meta.roles.some((role) => {
                //             console.log('inner check');
                //             return userRoles.includes(role)
                //         })
                //     }
                //     else
                //         return false
                // })

                
                let hasRole = to.meta.roles.some((role) => {
                    return userRoles.includes(role)
                })
                    
                if (!hasRole) {
                    next({
                        path: '/no-access',
                        params: { nextUrl: to.fullPath }
                    });
                }
                else{
                    next();
                }
            }
        }
        else{
            // if (localStorage.getItem('app_user_tokens') === null) {
            //     next({
            //         path: '/auth/login',
            //         params: { nextUrl: to.fullPath }
            //     });
            // }
            // else{
            //     next();
            // }
            next();
        }
    }
});

router.afterEach(() => {
});


export default router;